import { render } from "./empty-bucket.vue?vue&type=template&id=5b7ef0a2&scoped=true"
import script from "./empty-bucket.vue?vue&type=script&lang=js"
export * from "./empty-bucket.vue?vue&type=script&lang=js"

import "./empty-bucket.vue?vue&type=style&index=0&id=5b7ef0a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7ef0a2"]])

export default __exports__